module.exports = __webpack_public_path__ + "img/puntosdeventa.8815a19f.jpeg";